import React, { useState,useEffect } from 'react';
// import clsx from 'clsx';
// import PropTypes from 'prop-types';
// import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid,

} from '@material-ui/core';




import { differenceInDays, addDays, isSameDay, isWithinInterval, format, parseISO } from 'date-fns';
// import * as isWithinRange from 'date-fns/is_within_range';
import _ from 'lodash';

import {
  Session,
} from '../';

// const useStyles = makeStyles(theme => ({
//   root: {
//     width: '100%',
//     backgroundColor: theme.palette.background.paper,
//   },

// }));

// function usePrevious(value) {
//   const ref = useRef();
//   useEffect(() => {
//     ref.current = value;
//   });
//   return ref.current;
// }

const Meal = props => {
  const { className, sessions, mealsTypes, onChecked, ...rest } = props;

  // const classes = useStyles();

// console.log('Meal', sessions[0].startDate, sessions[0].endDate )

// const daysDiff = differenceInDays(sessions[0].endDate, sessions[0].startDate) + 1
// console.log('Meal',daysDiff)
// console.log('Meal',mealsTypes)

// const startDate= parseISO('2020-02-01')
// const endDate = addDays(parseISO('2020-02-03'),1)
// console.log(new Date(),startDate, endDate)
// console.log(isWithinInterval(new Date(),{start: startDate, end: endDate}))
// isWithinInterval включает левую границу но не включает правую

// const days = _.range(
//   0,
//   daysDiff,
//   1
//   ).map(daysNum => {
//     const currentDay = addDays(sessions[0].startDate, daysNum)
//     return {
//       date: currentDay,
//       weekend: _.filter(sessions[0].weekends, (w) => {
//         return isSameDay(w,currentDay);
//     }).length === 0 ? false : true,
//       meals: mealsTypes.map(m=>{
//         return {
//             id: m.id,
//             name: m.name,
//             price: m.price,
//             selected: false
//         }
//       }) 
//     }
//   })

  // console.log('Meal',days)
  const [checked, setChecked] = useState( {} )
  // const checkedPrevious = usePrevious(checked)
  // const checkedPrevious = useRef(checked);checkedPrevious.current = checked;


  const [sessionsPrepared, setSessionsPrepared] = useState( [] )
  
  const makeDays = (currentDay, s, mealsTypesList) =>{
    return {
      date: format(currentDay,'dd.MM.yyyy'),
      weekend: _.filter(s.weekends, (w) => {
        return isSameDay(w,currentDay);
    }).length === 0 ? false : true,
      meals: mealsTypesList.map(m=>{
        return {
            id: m.id,
            name: m.name,
            price: m.price,
            // selected: false
            amount: 0
        }
      }) 
    }
  }


  useEffect(() => {

    const res = sessions.map(s =>{
      const daysDiff = differenceInDays(s.endDate, s.startDate) + 1
      return (
        {
        id: s.id,
        open: isWithinInterval(new Date(),{start: s.startDate, end: addDays(s.endDate,1)}),
        name: s.name,
        days: _.range(
          0,
          daysDiff,
          1
          ).map(daysNum => {
            const currentDay = addDays(s.startDate, daysNum)
            if (daysNum === 0 ){
              // console.log('meal days generate',0, currentDay);
              return makeDays(currentDay, s, _.filter(mealsTypes, function(o) { return o.name !== 'Завтрак'; } ))
              // return {
              //   date: format(currentDay,'dd.MM.yyyy'),
              //   weekend: _.filter(s.weekends, (w) => {
              //     return isSameDay(w,currentDay);
              // }).length === 0 ? false : true,
              //   meals: _.filter(mealsTypes, function(o) { return o.name !== 'Завтрак'; } ).map(m=>{
              //     return {
              //         id: m.id,
              //         name: m.name,
              //         price: m.price,
              //         // selected: false
              //         amount: 0
              //     }
              //   }) 
              // }
            }

            if (daysNum === daysDiff -1 ){
              return makeDays(currentDay, s, _.filter(mealsTypes, function(o) { return o.name === 'Завтрак'; } ))

              // console.log('meal days generate',daysDiff, currentDay);
              // return {
              //   date: format(currentDay,'dd.MM.yyyy'),
              //   weekend: _.filter(s.weekends, (w) => {
              //     return isSameDay(w,currentDay);
              // }).length === 0 ? false : true,
              //   meals: _.filter(mealsTypes, function(o) { return o.name === 'Завтрак'; } ).map(m=>{
              //     return {
              //         id: m.id,
              //         name: m.name,
              //         price: m.price,
              //         // selected: false
              //         amount: 0
              //     }
              //   }) 
              // }

            }
            return makeDays(currentDay, s, mealsTypes)
            // return {
            //   date: format(currentDay,'dd.MM.yyyy'),
            //   weekend: _.filter(s.weekends, (w) => {
            //     return isSameDay(w,currentDay);
            // }).length === 0 ? false : true,
            //   meals: mealsTypes.map(m=>{
            //     return {
            //         id: m.id,
            //         name: m.name,
            //         price: m.price,
            //         // selected: false
            //         amount: 0
            //     }
            //   }) 
            // }
          })
      })
    })
    // console.log('Meal useEffect res', res)
    // console.log('Meal useEffect res', _.orderBy(res, ['name'], ['asc']))

    
    setSessionsPrepared(res)

    // Дефолтное состояние все булочки свежие
    const ch =   _.reduce(res , function(obj, s) {
      obj[s.id] =  
      
        _.reduce(s.days , function(days, d) {
          days[d.date] = 
    
          _.reduce(d.meals , function(meals, m) {
            // meals[m.id] = false
            meals[m.id] = 0
              return meals;
            }, {})
    
          return days;
        }, {})
    
       return obj;
     }, {})
    
      // console.log('Meal useEffect ch', ch)
      // console.log('Meal useEffect ch res', res[0] ? res[0].id : '', res[0] ? ch[res[0].id] : '' )
    

    setChecked(ch)
  }, [props.sessions]);



  useEffect(() => {
    // setChecked(ch)
    // console.log('sessionsPrepared',sessionsPrepared);
    // console.log('checked',checked);
    // console.log('props.coupons',props.coupons);
    const coupons =  _.map(props.coupons, (value, key) => {
      return {
        date: format(parseISO(value.Eventeating.date),'dd.MM.yyyy'),
        amount: value.amount,
        mealId: value.Meal.id,
        meetingId: value.Eventeating.meeting_id
      }
    });
    // console.log('coupons', coupons);

    let checkedMeal = _.cloneDeep(checked)
    // Установим значения из купонов
        _.forEach(coupons, function(c) {
      checkedMeal[c.meetingId][c.date][c.mealId] = c.amount
    })
    setChecked(checkedMeal)
    onChecked(checkedMeal)


    //     _.forEach(checkedMeal, function(sessionsDates, sessionId) {
//       _.forEach(sessionsDates, function(dateMeals, date) {
//           _.forEach(dateMeals, function(mealState, mealId) {
// // 
//             // console.log('coupons filtred', date, mealId,            
//             // _.filter(coupons, function(o) { return o.date === date })
//             const c= _.filter(coupons, function(o) { return o.date === date && parseInt(o.mealId) === parseInt(mealId)})
//             if (c.length > 0)
//             {
//               mealState = c[0]. amount
//             }
//             // _.filter(coupons, function(o) { return parseInt(o.mealId) === parseInt(mealId)})
//             // )


//           });
//       });
//     });

    // console.log('checkedMeal', checkedMeal);

  }, [props.coupons]);

  const handleCheckedOne = (sessionCheced) => {
    // console.log(params)
    // console.log('handleCheckedOne meal', sessionCheced)
    // props.onCheckedOne({[id]: _.assign(checked, dayChecked) })
      // _.forEach(newChecked, function(session_value, session_key) {
      //   _.forEach(session_value, function(day_value, day_key) {
      //     _.forEach(day_value, function(meal_value, meal_key) {
    // const before = _.clone(checked[_.keys(sessionCheced)[0]])
    

    // console.log('before', checkedPrevious);
    // console.log('checked',checked[_.keys(sessionCheced)[0]]);
    // console.log('sessionCheced',sessionCheced[_.keys(sessionCheced)[0]]);
    
    // _.forEach(sessionCheced[_.keys(sessionCheced)[0]], function(day_value, day_key) {
    //     _.forEach(day_value, function(meal_value, meal_key) {
    //       console.log('day_value',day_key, meal_key, meal_value);
    //       const diff = meal_value - checkedPrevious[day_key][meal_key]
    //       console.log('diff', diff);
    //     });
    // });


    const checkedNew = _.assign(checked, sessionCheced)
    // console.log('handleCheckedOne meal',checkedNew)
    setChecked( checkedNew)
    onChecked(checkedNew)

  }

  return (
    <Card
    {...rest}
  // className={clsx(classes.root, className)}
  >
    <form
      autoComplete="off"
      noValidate
    >



      <CardHeader
        title="Питание"
      />
      <Divider />
      <CardContent>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            xs={12}
          >
{
  _.orderBy(sessionsPrepared, ['name'], ['asc']).map((s, index) => (
    <Session
      key={index}
      session={s}
      checked={checked[s.id]}
      onCheckedOne={handleCheckedOne}
      mealsTypes={mealsTypes}
    />
  )
  )}

{/*  */}
          
          </Grid>
        </Grid>
      </CardContent>
    </form>
  </Card>

  );
};


export default Meal;
